import styled from '@emotion/styled';
import { Box, Card, Typography } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const MoreArticlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0;
  @media (max-width: 900px) {
    order: 2;
    width: 100%;
  }
`;

export const MoreArticlesHeader = styled.span`
  color: ${customPalette.grey[400]};
  margin: 0;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.15px;
`;

export const ArticleItem = styled(Card)({
  width: '100%',
  borderRadius: '16px',
  backgroundColor: customPalette.accent.white,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  boxShadow: 'none',
  maxWidth: '772px',
});

export const ArticleContentComponent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: '24px',
  '@media (max-width: 900px)': {
    padding: '16px',
  },
});

export const ArticleDateTypography = styled(Typography)({
  fontSize: '12px',
  lineHeight: '130%',
  fontWeight: '500',
  color: customPalette.accent.main,
  margin: '0 0 12px 0',
});

export const ArticleTitleTypography = styled(Typography)({
  fontSize: '18px',
  lineHeight: '120%',
  fontWeight: 700,
  letterSpacing: '0.15px',
  color: customPalette.accent.main,
  margin: '0',
});

export const ArticleSummaryAndLinkContainer = styled.div({
  margin: '12px 0 0 0',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  color: customPalette.accent.main,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '150%',
  justifyContent: 'left',
  alignItems: 'self-start',
});

export const ReadMoreLink = styled.a`
  font-size: 14px;
  color: ${customPalette.blue.main};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
